<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-[#111B21] print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall"
>
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex w-full items-center p-4 pl-6 bg-[#202C33]">
            <!-- Logo -->
            <div class="flex items-center justify-center">
                <img class="w-8" src="images/logo/logo.svg" />
            </div>
            <!-- Components -->
            <div class="ml-auto flex items-center space-x-2">
                <workspaces></workspaces>
                <user></user>
            </div>
        </div>
        <!-- User -->
        <div class="flex w-full flex-col items-center p-4 bg-[#111B21]">
            <div class="relative h-24 w-24">
                <mat-icon
                    class="icon-size-24 text-[#8696A0]"
                    [svgIcon]="'heroicons_solid:user-circle'"
                ></mat-icon>
            </div>
            @if (user) {
                <div class="mt-6 flex w-full flex-col items-center justify-center">
                    <div
                        class="w-full overflow-hidden text-ellipsis whitespace-nowrap text-center font-medium leading-normal text-[#E9EDEF]"
                    >
                        {{ user ? user.firstName + ' ' + user.lastName : ('user.guestUser' | transloco) }}
                    </div>
                    <div
                        class="mt-0.5 w-full overflow-hidden text-ellipsis whitespace-nowrap text-center text-md font-medium leading-normal text-[#8696A0]"
                    >
                        {{ user?.email || ('user.noEmail' | transloco) }}
                    </div>
                </div>
            }
        </div>
    </ng-container>
    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationContentFooter>
        <div
            class="mb-4 mt-2 flex h-16 flex-0 items-center justify-center pl-2 pr-6 opacity-12 bg-[#111B21]"
        >
            <img class="max-w-36" src="images/logo/logo-text-on-dark.svg" />
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div
        class="relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow bg-[#202C33] border-[#2A3942] md:px-6 print:hidden"
    >
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')" class="text-[#8696A0]">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <!-- Components -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
            <languages></languages>
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-auto flex-col">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer -->
    <!--<div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
    </div>-->
</div>
